"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTermDisplayName = getTermDisplayName;
exports.getFinalTermDisplayName = getFinalTermDisplayName;
/**
 * Returns the same display name used for terms throughout DegreePlan.
 */
function getTermDisplayName(term) {
    return term.clientName || term.name || '';
}
/**
 * Returns the name of the term at the greatest plan position. The app presents
 * this as Final Term Active; student-facing exports use Expected Graduation Term.
 */
function getFinalTermDisplayName(termPlans) {
    if (termPlans.length === 0)
        return '';
    const finalTermPlan = termPlans.reduce((latest, current) => current.position > latest.position ? current : latest);
    return getTermDisplayName(finalTermPlan.term);
}
